/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicaidCase } from './MedicaidCase';
import {
    MedicaidCaseFromJSON,
    MedicaidCaseFromJSONTyped,
    MedicaidCaseToJSON,
    MedicaidCaseToJSONTyped,
} from './MedicaidCase';

/**
 * 
 * @export
 * @interface MedicaidCaseResponse
 */
export interface MedicaidCaseResponse {
    /**
     * 
     */
    data: MedicaidCase;
}

/**
 * Check if a given object implements the MedicaidCaseResponse interface.
 */
export function instanceOfMedicaidCaseResponse(value: object): value is MedicaidCaseResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MedicaidCaseResponseFromJSON(json: any): MedicaidCaseResponse {
    return MedicaidCaseResponseFromJSONTyped(json, false);
}

export function MedicaidCaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MedicaidCaseFromJSON(json['data']),
    };
}

export function MedicaidCaseResponseToJSON(json: any): MedicaidCaseResponse {
    return MedicaidCaseResponseToJSONTyped(json, false);
}

export function MedicaidCaseResponseToJSONTyped(value?: MedicaidCaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicaidCaseToJSON(value['data']),
    };
}

